import { Car } from '@upstart/harmony/lib/legos/carTypes';
import { useDispatch, useStore } from 'react-redux';
import { useMutation } from 'react-query';
import CarService from '../services/CarService';
import { getSelectedCars } from '../redux/deals/selectors';
import { selectedCarsUpdateCar } from '../redux/deals/actions';

export const useCarMutation = () => {
  const store = useStore();
  const dispatch = useDispatch();
  return useMutation(
    ({ id, ...rest }: { id: string; mileage: string }) =>
      CarService.updateCar(id, rest),
    {
      onMutate(car) {
        // optimistic update currently we need to understand the redux store to make these updates
        const selectedCars = getSelectedCars(store.getState());
        const oldCar = selectedCars?.find((c: Car) => c.id === car.id);
        dispatch(selectedCarsUpdateCar(car));
        return { oldCar };
      },
      onError(err, updateParams, oldContext) {
        dispatch(selectedCarsUpdateCar((oldContext as { oldCar: Car }).oldCar));
      },
    },
  );
};
